export const SEPARATOR_TAG = "@separator";
export const OVERRIDE_TAG = "@override";
export const GUEST_TAG = `${OVERRIDE_TAG}=guest`;
export const USER_TAG = `${OVERRIDE_TAG}=user`;
